// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideRotateCcw as RawLucideRotateCcw } from "lucide-react";
export const LucideRotateCcw = /* @__PURE__ */ createIcon(RawLucideRotateCcw, "LucideRotateCcw", 2);
